module.exports = __webpack_public_path__ + "img/commandeLivraison.9120af5c.png";